// /s/{id}: a share's session (byj-1wv.3.10), the share loaded and its view
// drawn (components/SessionView, which the exam edition's console draws
// too, RFC-062).
import { useEffect, useState } from "react";
import { api, type ShareDetail, type User } from "../api";
import { PageLoading, PageNotice } from "../components/Page";
import { SessionView } from "../components/SessionView";
import { navigate } from "../router";
import { t } from "../i18n";

/** The loader: who I am and what the share is, then the view. */
export function Session({ id, me }: { id: string; me: User }) {
  const [share, setShare] = useState<ShareDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api.share(id).then(setShare, (err: unknown) => setError(err instanceof Error ? err.message : String(err)));
  }, [id]);
  if (error) {
    return (
      <PageNotice error={error}>
        <a href="/shares" onClick={(e) => (e.preventDefault(), navigate("/shares"))}>
          {t("common:backToShares")}
        </a>
      </PageNotice>
    );
  }
  if (!share) return <PageLoading />;
  return <SessionView share={share} me={me} onShare={setShare} />;
}
